<!-- Footer Component -->
<script>
  import { Col, Row, Container } from "sveltestrap";
  import { t, locale, locales } from "../Services/i18n";
</script>

<footer class="footer">
  <Container>
    <Row>
      <Col lg="4" class="mt-4">
        <h4>{$t("footer.information")}</h4>
        <div class="text-muted mt-4">
          <ul class="list-unstyled footer-list">
            <li><a href={"#"}>{$t("nav.home")}</a></li>
            <li><a href={"#services"}>{$t("nav.practice")}</a></li>
            <li><a href={"#about"}>{$t("nav.about")}</a></li>
          </ul>
        </div>
      </Col>
      <Col lg="4" class="mt-4">
        <h4>{$t("footer.support")}</h4>
        <div class="text-muted mt-4">
          <ul class="list-unstyled footer-list">
            <li><a href={"#contact"}>{$t("nav.contact")}</a></li>
          </ul>
        </div>
      </Col>
      <Col lg="4" class="mt-4">
        <h4>Maite M. Matos Law</h4>    
        <div class="text-muted mt-4">
          <p>
            {new Date().getFullYear()}© Matos Law - {$t("footer.allrightsreserved")}
          </p>
        </div>
      </Col>
    </Row>
  </Container>
</footer>
<!--END FOOTER-->

<!--START FOOTER ALTER-->
<!-- <div class="footer-alt">
  <Container>
    <Row>
      <Col lg="12">
        <div class="float-start pull-none ">
          <p class="copy-rights text-muted">
            {new Date().getFullYear()}
            © All Axis
          </p>
        </div>
        <div class="clearfix" />
      </Col>
    </Row>
  </Container>
</div> -->
<!--START FOOTER ALTER-->
